import * as React from 'react';

export const IconClose = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
    <path fill="currentColor" fillRule="evenodd"
          d="M4.571 4L8 .571 7.429 0 4 3.429.571 0 0 .571 3.429 4 0 7.429.571 8 4 4.571 7.429 8 8 7.429z"/>
  </svg>
);
